import React from 'react'
import propTypes from 'prop-types'
import Cog from './Cog'

import './AppSettings.css'


const AppSettings = ({ user }) => (
  <div className='app-settings'>
    <span className='user-name'>{user.displayName}</span>
    <a href='/#'>
    <Cog />
    </a>
  </div>
)

AppSettings.propTypes = {
  user: propTypes.object,
}


export default AppSettings



// WEBPACK FOOTER //
// ./src/components/AppSettings/AppSettings.js